/* src/app/warehousing/partials/storage-rate-form/storage-rate-form.component.scss */
/*# sourceMappingURL=storage-rate-form.component.css.map */
